import pxToRem from "hooks/usePxToRem";

const defaultInputConfigs = {
  MuiInputBase: {
    styleOverrides: {
      input: {
        fontSize: pxToRem(14),
        "&::placeholder": {
          fontSize: pxToRem(14),
        },
      },
    },
  },
  MuiTextField: {
    defaultProps: {size: "small" as "small" | "medium"},
  },
  MuiInputLabel: {
    styleOverrides: {
      root: ({theme}) => ({
        fontSize: pxToRem(14),
        color: theme.palette.grey[500],
        "&::disabled": {
          color: theme.palette.grey[300],
        },
      }),
    },
  },
};

export default defaultInputConfigs;
